// extracted by mini-css-extract-plugin
module.exports = {"hiatus":"styles_hiatus__2w2Nv"};